import React, {Component} from 'react';
import {Col, Form, FormGroup, ControlLabel, FormControl, Checkbox, InputGroup, ButtonToolbar} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import TopDostepnosc from "../../../../../componentsTopsa/dostepnosc/TopDostepnosc";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import DefinicjeService from "../../../trasyConfig/definicjeTras/DefinicjeService";
import DateAndTimeFormat from "../../../../../utilities/DateAndTimeFormat";
import moment from 'moment'
import TopIf from "../../../../../componentsTopsa/if/TopIf";

export default class PromocjeForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trasa: null,
            dataOd: null,
            dataDo: null,
            godzinaOd: '',
            godzinaDo: '',
            miejscowoscOd: null,
            miejscowoscDo: null,
            miejscowosci: [],
            typ: {typ: 0, nazwa: "dokładnie od do PLN"},
            wartosc: '',
            czyBylPrzycisk: false,
            validatorMessages: [],
            czyLimitBiletow: false,
            ileBiletow: '',
            typy: [
                {typ: 0, nazwa: "dokładnie od do PLN"},
                {typ: 1, nazwa: "dokładnie od do %"},
                {typ: 2, nazwa: "na całym odcinku PLN"},
                {typ: 3, nazwa: "na całym odcinku %"},
            ]

        };
        this.pobierzMiejscowosciWTrasie = this.pobierzMiejscowosciWTrasie.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeTrasa = this.onChangeTrasa.bind(this)
        this.onChangeDataOd = this.onChangeDataOd.bind(this)
        this.onChangeDataDo = this.onChangeDataDo.bind(this)
        this.onChangeMiejscowoscOd = this.onChangeMiejscowoscOd.bind(this)
        this.onChangeMiejscowoscDo = this.onChangeMiejscowoscDo.bind(this)
        this.onChangeGodzinaOd = this.onChangeGodzinaOd.bind(this)
        this.onChangeGodzinaDo = this.onChangeGodzinaDo.bind(this)
        this.onChangeTyp = this.onChangeTyp.bind(this)
        this.onChangeWartosc = this.onChangeWartosc.bind(this)
        this.onChangeIlosc = this.onChangeIlosc.bind(this)
    }

    componentDidMount() {
        if (Boolean(this.props.edytowana)) {

            DefinicjeService.pobierzMiejscowosciNaTrasie(this.props.edytowana.idTr).then(function (response) {
                let arr = response.data;
                this.setState({
                    miejscowosci: arr,
                    trasa: this.props.trasy.find(t => t.idTr === this.props.edytowana.idTr),
                    dataOd: moment(this.props.edytowana.dataOd),
                    dataDo: moment(this.props.edytowana.dataDo),
                    godzinaOd: DateAndTimeFormat.formatNormalTime(this.props.edytowana.godzOd),
                    godzinaDo: DateAndTimeFormat.formatNormalTime(this.props.edytowana.godzDo),
                    miejscowoscOd: arr.find(m => m.idMi === this.props.edytowana.idMiOd),
                    miejscowoscDo: arr.find(m => m.idMi === this.props.edytowana.idMiDo),
                    typ: this.state.typy.find(t => t.typ === this.props.edytowana.typ),
                    wartosc: this.props.edytowana.wart,
                    czyLimitBiletow: Boolean(this.props.edytowana.ileBiletow),
                    ileBiletow: Boolean(this.props.edytowana.ileBiletow)? this.props.edytowana.ileBiletow : ''
                })

                document.getElementById('inputGodzOd').value = DateAndTimeFormat.formatNormalTime(this.props.edytowana.godzOd)
                document.getElementById('inputGodzDo').value = DateAndTimeFormat.formatNormalTime(this.props.edytowana.godzDo)
                document.getElementById('inputWartosc').value = this.props.edytowana.wart
                this.ustawWartoscInputaIloscBiletow(this.props.edytowana.ileBiletow)



            }.bind(this))
        }
        else{
            // ustawienie na start dat i godzin
            this.setState({
                dataOd: moment(),
                dataDo: moment(),
                godzinaOd: '00:00',
                godzinaDo: '23:59',
            })
            document.getElementById('inputGodzOd').value = DateAndTimeFormat.formatNormalTime('00:00')
            document.getElementById('inputGodzDo').value = DateAndTimeFormat.formatNormalTime('23:59')
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.edytowana) {

            DefinicjeService.pobierzMiejscowosciNaTrasie(nextprops.edytowana.idTr).then(function (response) {

                let arr = response.data;
                this.setState({
                    miejscowosci: arr,
                    trasa: this.props.trasy.find(t => t.idTr === nextprops.edytowana.idTr),
                    dataOd: moment(nextprops.edytowana.dataOd),
                    dataDo: moment(nextprops.edytowana.dataDo),
                    godzinaOd: DateAndTimeFormat.formatNormalTime(nextprops.edytowana.godzOd),
                    godzinaDo: DateAndTimeFormat.formatNormalTime(nextprops.edytowana.godzDo),
                    miejscowoscOd: arr.find(m => m.idMi === nextprops.edytowana.idMiOd),
                    miejscowoscDo: arr.find(m => m.idMi === nextprops.edytowana.idMiDo),
                    typ: this.state.typy.find(t => t.typ === nextprops.edytowana.typ),
                    wartosc: nextprops.edytowana.wart,
                    czyLimitBiletow: Boolean(nextprops.edytowana.ileBiletow),
                    ileBiletow: Boolean(nextprops.edytowana.ileBiletow)? nextprops.edytowana.ileBiletow : ''
                })

                document.getElementById('inputGodzOd').value = DateAndTimeFormat.formatNormalTime(nextprops.edytowana.godzOd)
                document.getElementById('inputGodzDo').value = DateAndTimeFormat.formatNormalTime(nextprops.edytowana.godzDo)
                document.getElementById('inputWartosc').value = nextprops.edytowana.wart
                this.ustawWartoscInputaIloscBiletow(nextprops.edytowana.ileBiletow)



            }.bind(this))
        }
    }

    ustawWartoscInputaIloscBiletow(wartosc){
        if(Boolean(wartosc)){
            document.getElementById('inputIlosc').value = wartosc
        }

    }

    onChangeTrasa(e) {
        if (e !== null) {
            this.setState({
                trasa: e,
                miejscowoscOd: null,
                miejscowoscDo: null,
            })
            this.pobierzMiejscowosciWTrasie(e)
        }
    }

    onChangeDataOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDataDo(e) {
        this.setState({dataDo: e})
    }

    onChangeMiejscowoscOd(e) {
        this.setState({miejscowoscOd: e})
    }

    onChangeMiejscowoscDo(e) {
        this.setState({miejscowoscDo: e})
    }

    onChangeGodzinaOd(e) {
        this.setState({godzinaOd: e.target.value})
    }

    onChangeGodzinaDo(e) {
        this.setState({godzinaDo: e.target.value})
    }

    onChangeTyp(e) {
        this.setState({typ: e})
    }

    onChangeWartosc(e) {
        this.setState({wartosc: e.target.value})
    }

    onChangeIlosc(e) {
        this.setState({ileBiletow: e.target.value})
    }

    pobierzMiejscowosciWTrasie(trasa) {
        DefinicjeService.pobierzMiejscowosciNaTrasie(trasa.idTr).then(function (response) {
            // okreslenie na start miejscowosci od do
            this.setState({miejscowosci: response.data, miejscowoscOd:response.data[0], miejscowoscDo:response.data[response.data.length-1]})
        }.bind(this))
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages;
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {

        this.setState({czyBylPrzycisk: true, validatorMessages: []})
        let poprawne = true;
        this.state.validatorMessages = [];

        if (!Boolean(this.state.trasa)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano trasy')
        }
        if (!Boolean(this.state.miejscowoscOd)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano miejscowości od')
        }
        if (!Boolean(this.state.miejscowoscDo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano miejscowości do')
        }
        if (this.state.miejscowosci.indexOf(this.state.miejscowoscOd) > this.state.miejscowosci.indexOf(this.state.miejscowoscDo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Miejscowść od nie może być w późniejszej kolejności niż miejscowość do')
        }
        if (!Boolean(this.state.typ)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano typu')
        }
        if (this.state.wartosc.length == 0) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono wartości zniżki')
        }
        if (this.state.typ.typ % 2 == 0) {
            // typ jest PLN
            if (!Validator.validateIntOrDouble(this.state.wartosc, false)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Wartość musi być liczbą nieujemną')
            }
        }
        else {
            // typ to %
            if (!Validator.validateInt(this.state.wartosc, false)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Wartość musi być liczbą całkowitą nieujemną')
            }
            if (this.state.wartosc > 100) {
                poprawne = false;
                this.dodajDoValidatorMessages('Wartość musi mieścić się w zakresie 0 - 100')
            }
        }

        if (this.state.czyLimitBiletow) {
            if (this.state.ileBiletow.length == 0) {
                poprawne = false;
                this.dodajDoValidatorMessages('Nie uzupełniono ilości biletów')
            }
            if (!Validator.validateInt(this.state.ileBiletow, false)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Ilość biletów musi być liczbą całkowitą nieujemną')
            }
        }

        if (!Boolean(this.state.dataOd)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano daty od')
        }
        if (!Boolean(this.state.dataDo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano daty do')
        }
        if (this.state.dataOd > this.state.dataDo) {
            poprawne = false;
            this.dodajDoValidatorMessages('Data od nie może być późniejsza od daty do')
        }
        if (!Boolean(this.state.godzinaOd)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano godziny od')
        }
        if (!Boolean(this.state.godzinaDo)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie wybrano godziny do')
        }
        if (DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo) == DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd)) {
            if (this.state.godzinaOd > this.state.godzinaDo) {
                poprawne = false;
                this.dodajDoValidatorMessages('Godzina od nie może być późniejsza niż godzina do')
            }
        }

        if (poprawne) {
            this.state.validatorMessages = [];
            this.setState({czyBylPrzycisk: false, validatorMessages: []})

            let data = {
                "dataDo": DateAndTimeFormat.formatYYYYMMDD(this.state.dataDo),
                "dataOd": DateAndTimeFormat.formatYYYYMMDD(this.state.dataOd),
                "godzDo": parseFloat((this.state.godzinaDo).replace(':', '.')),
                "godzOd": parseFloat((this.state.godzinaOd).replace(':', '.')),
                "idMiDo": this.state.miejscowoscDo.idMi,
                "idMiOd": this.state.miejscowoscOd.idMi,
                "idTr": this.state.trasa.idTr,
                "wart": this.state.wartosc,
                "typ": this.state.typ.typ,
                "ileBiletow": Boolean(this.state.czyLimitBiletow) ? this.state.ileBiletow : null
            }
            this.props.handleZapisz(data, Boolean(this.props.edytowana))
        }
    }

    formatTrasaSelect(option) {
        return (
            <div>
                <span className={'label label-ebus-primary'}>{option.kodTrasy}</span>
                {' ' + option.nazTr}
                <TopDostepnosc wartoscWarunek={0}
                               wartosc={option.status}
                               czyMarginesLewy={true}/>
            </div>
        )
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.edytowana) ? 'Edycja promocji' : 'Nowa promocja'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={6} lg={3}>
                                <ControlLabel>Trasa</ControlLabel>
                                <TopSelect onChange={this.onChangeTrasa} value={this.state.trasa}
                                           options={this.props.trasy} labelKey={'nazTr'}
                                           valueKey={'idTr'} valueRenderer={this.formatTrasaSelect}
                                           optionRenderer={this.formatTrasaSelect}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Miejscowość od</ControlLabel>
                                <TopSelect onChange={this.onChangeMiejscowoscOd} value={this.state.miejscowoscOd}
                                           options={this.state.miejscowosci} labelKey={'nazMi'} valueKey={'idMi'}
                                           disabled={!Boolean(this.state.trasa)}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Miejscowość do</ControlLabel>
                                <TopSelect onChange={this.onChangeMiejscowoscDo} value={this.state.miejscowoscDo}
                                           options={this.state.miejscowosci} labelKey={'nazMi'} valueKey={'idMi'}
                                           disabled={!Boolean(this.state.trasa)}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Typ</ControlLabel>
                                <TopSelect onChange={this.onChangeTyp} value={this.state.typ} valueKey={'typ'} labelKey={'nazwa'}
                                           options={this.state.typy} clearable={false}/>
                            </Col>
                            <Col xs={6} lg={1}>
                                <ControlLabel>Zniżka {(this.state.typ.typ % 2 == 0) ? 'PLN' : '%'}</ControlLabel>
                                <FormControl type={'number'} onChange={this.onChangeWartosc} id={'inputWartosc'}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <TopIf isTrue={!this.state.czyLimitBiletow}>
                                    <div className={'add-label-margin'}></div>
                                </TopIf>
                                <Checkbox onClick={() => {
                                    this.setState({czyLimitBiletow: !this.state.czyLimitBiletow})
                                }} checked={this.state.czyLimitBiletow}>
                                    Czy jest limit biletów?
                                    {Boolean(this.state.czyLimitBiletow) ?
                                        <span style={{fontWeight: 'bold'}}> Tak, ilość:</span>
                                        :
                                        <span style={{fontWeight: 'bold'}}> Nie</span>}
                                </Checkbox>
                                <TopIf isTrue={this.state.czyLimitBiletow}>
                                    <FormControl type={'number'} onChange={this.onChangeIlosc} id={'inputIlosc'}/>
                                </TopIf>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Data od</ControlLabel>
                                <TopInputDate onChange={this.onChangeDataOd} value={this.state.dataOd}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Data do</ControlLabel>
                                <TopInputDate onChange={this.onChangeDataDo} value={this.state.dataDo}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Godzina od</ControlLabel>
                                <FormControl type={'time'} onChange={this.onChangeGodzinaOd} id={'inputGodzOd'}/>
                            </Col>
                            <Col xs={6} lg={2}>
                                <ControlLabel>Godzina do</ControlLabel>
                                <FormControl type={'time'} onChange={this.onChangeGodzinaDo} id={'inputGodzDo'}/>
                            </Col>
                            <Col xs={12} lg={4}>
                                <div className={'add-label-margin'}></div>
                                <ButtonToolbar>
                                    <TopButtonCancel onClick={() => {
                                        this.props.handleAnuluj()
                                    }}/>
                                    <TopButtonSave onClick={this.onClickZapisz}/>
                                </ButtonToolbar>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <ValidatorMessages messages={this.state.validatorMessages}/>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/biletyConfig/promocje/components/PromocjeForm.js